import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SearchService } from '../services/search.service';
import { UserProfileComponent } from './user-profile/user-profile.component';

@Component({
  selector: 'app-sidebar',
  imports: [RouterModule,UserProfileComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  public searchService = inject(SearchService);
}
